





















































import 'vue-material-design-icons/styles.css'
import Ribbon from 'vue-ribbon'
import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle'
import RightIcon from 'vue-material-design-icons/ChevronRightCircle'
import PlusIcon from 'vue-material-design-icons/PlusCircle'
import MinusIcon from 'vue-material-design-icons/MinusCircle'
import Flipbook from './Flipbook'

export default
  name: 'app'
  components: { Flipbook, LeftIcon, RightIcon, PlusIcon, MinusIcon, Ribbon }
  data: ->
    pages: [],
    pagesHiRes: [],
    hasMouse: true
    pageNum: null
  methods:
    onFlipLeftStart: (page) -> console.log 'flip-left-start', page
    onFlipLeftEnd: (page) ->
      console.log 'flip-left-end', page
      window.location.hash = '#' + page
    onFlipRightStart: (page) -> console.log 'flip-right-start', page
    onFlipRightEnd: (page) ->
      console.log 'flip-right-end', page
      window.location.hash = '#' + page
    onZoomStart: (zoom) -> console.log 'zoom-start', zoom
    onZoomEnd: (zoom) -> console.log 'zoom-end', zoom
    setPageFromHash: ->
      n = parseInt window.location.hash.slice(1), 10
      @pageNum = n if isFinite n
  mounted: ->
    window.addEventListener 'keydown', (ev) =>
      flipbook = @$refs.flipbook
      return unless flipbook
      flipbook.flipLeft() if ev.keyCode == 37 and flipbook.canFlipLeft
      flipbook.flipRight() if ev.keyCode == 39 and flipbook.canFlipRight

    # Simulate asynchronous pages initialization
    setTimeout (=>
      @pages = [
        null
        'images/Voyn-Dergi-Sayi-24-Sayfa-00.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-01.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-02.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-03.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-04.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-05.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-06.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-07.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-08.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-09.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-10.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-11.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-12.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-13.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-14.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-15.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-16.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-17.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-18.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-19.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-20.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-21.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-22.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-23.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-24.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-25.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-26.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-27.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-28.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-29.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-30.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-31.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-32.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-33.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-34.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-35.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-36.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-37.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-38.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-39.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-40.jpg'
        'images/Voyn-Dergi-Sayi-24-Sayfa-41.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-42.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-43.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-44.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-45.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-46.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-47.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-48.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-49.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-50.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-51.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-52.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-53.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-54.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-55.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-56.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-57.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-58.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-59.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-60.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-61.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-62.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-63.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-64.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-65.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-66.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-67.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-68.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-69.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-70.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-71.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-72.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-73.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-74.jpg'
        # 'images/Voyn-Dergi-Sayi-24-Sayfa-75.jpg'
    
        
      ]
      @pagesHiRes = [
        null
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-00.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-01.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-02.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-03.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-04.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-05.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-06.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-07.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-08.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-09.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-10.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-11.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-12.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-13.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-14.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-15.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-16.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-17.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-18.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-19.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-20.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-21.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-22.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-23.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-24.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-25.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-26.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-27.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-28.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-29.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-30.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-31.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-32.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-33.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-34.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-35.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-36.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-37.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-38.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-39.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-40.jpg'
        'images-large/Voyn-Dergi-Sayi-24-Sayfa-41.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-42.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-43.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-44.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-45.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-46.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-47.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-48.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-49.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-50.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-51.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-52.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-53.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-54.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-55.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-56.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-57.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-58.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-59.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-60.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-61.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-62.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-63.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-64.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-65.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-66.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-67.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-68.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-69.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-70.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-71.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-72.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-73.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-74.jpg'
        # 'images-large/Voyn-Dergi-Sayi-24-Sayfa-75.jpg'
 
      ]
    ), 1

    window.addEventListener 'hashchange', @setPageFromHash
    @setPageFromHash()
